import { useCallback } from "react";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { TaskType } from "../../task-management/types/TaskType";
import useCreateInitialTask from "@coworker/apprestructured/src/tasks/hooks/useCreateInitialTask";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

export function useResetFields(taskType: TaskType | Loading) {
  const createInitialTask = useCreateInitialTask();

  return useCallback(
    (fieldsToReset: string[], baseObject: Record<string, unknown> = {}) => {
      const initialTask = createInitialTask(taskType);

      return fieldsToReset.reduce((obj, field) => {
        return setByPath(field, getByPath(initialTask, field), obj);
      }, baseObject);
    },
    [createInitialTask, taskType]
  );
}
